/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S14_P1_AInputs */

const tr_mesafeli_s14_p1_a = /** @type {(inputs: Mesafeli_S14_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const en_mesafeli_s14_p1_a = /** @type {(inputs: Mesafeli_S14_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Platform is provided`)
};

const de_mesafeli_s14_p1_a = /** @type {(inputs: Mesafeli_S14_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform wird`)
};

const ru_mesafeli_s14_p1_a = /** @type {(inputs: Mesafeli_S14_P1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа предоставляется`)
};

/**
* | output |
* | --- |
* | "The Platform is provided" |
*
* @param {Mesafeli_S14_P1_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s14_p1_a = /** @type {((inputs?: Mesafeli_S14_P1_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S14_P1_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s14_p1_a(inputs)
	if (locale === "de") return de_mesafeli_s14_p1_a(inputs)
	if (locale === "ru") return ru_mesafeli_s14_p1_a(inputs)
	return tr_mesafeli_s14_p1_a(inputs)
});